import { Button, useMediaQuery, useTheme } from "@mui/material";

export const UM_TABLE_MIN_WIDTH = 700;

export const ACTIONS_COL_WIDTH = 100;

export const actionsColSx = {
  width: ACTIONS_COL_WIDTH,
  minWidth: ACTIONS_COL_WIDTH,
  maxWidth: ACTIONS_COL_WIDTH,
} as const;

export function ActionsEditButton({ onClick }: { onClick: () => void }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Button
      size={isMobile ? "medium" : "small"}
      variant="contained"
      color="secondary"
      onClick={onClick}
      sx={{
        textTransform: "none",
        fontWeight: 700,
        minHeight: isMobile ? 40 : undefined,
        px: isMobile ? 2 : undefined,
      }}
    >
      Edit
    </Button>
  );
}
